import { combineReducers } from 'redux';
import { alertsReducer as alerts, AlertsState } from './alerts';
import { archiveViewReducer as archiveView, ArchiveViewState } from './archiveView';
import { contactViewReducer as contactView, ContactViewState } from './contactView';
import { contextMenuReducer as contextMenu, ContextMenuState } from './contextMenu';
import { groupViewReducer as groupView, GroupViewState } from './groupView';
import { locationReducer as location, LocationState } from './location';
import { modalReducer as modal, ModalState } from './modal';
import { navBarReducer as navBar, NavBarState } from './navBar';
import { scrollPositionReducer as scrollPosition, ScrollPositionState } from './scrollPosition';
import { selectedReducer as selected, SelectedState } from './selected';
import { viewRestorationReducer as viewRestoration, ViewRestorationState } from './viewRestoration';
import { welcomeGuideReducer as welcomeGuide, WelcomeGuideState } from './welcomeGuide';
import { sourceLabelsReducer as sourceLabels, SourceLabelsState } from './sourceLabels';
import { panelSizingReducer as panelSizing, PanelSizingState } from './panelSizing';

export interface AppUI {
  alerts: AlertsState;
  archiveView: ArchiveViewState;
  contactView: ContactViewState;
  contextMenu: ContextMenuState;
  groupView: GroupViewState;
  location: LocationState;
  modal: ModalState;
  navBar: NavBarState;
  panelSizing: PanelSizingState;
  scrollPosition: ScrollPositionState;
  selected: SelectedState;
  sourceLabels: SourceLabelsState;
  viewRestoration: ViewRestorationState;
  welcomeGuide: WelcomeGuideState;
}

const uiReducer = combineReducers({
  alerts,
  archiveView,
  contactView,
  contextMenu,
  groupView,
  location,
  modal,
  navBar,
  panelSizing,
  scrollPosition,
  selected,
  sourceLabels,
  viewRestoration,
  welcomeGuide,
});

export default uiReducer;
